// Collection filter variant stock overlay handler
class VariantStockOverlay {
  constructor() {
    console.log('VariantStockOverlay initialized');
    this.productCards = document.querySelectorAll('.card-wrapper, .product-card-wrapper');
    console.log('Found product cards:', this.productCards.length);
    this.init();
  }

  init() {
    // Listen for Dawn's facet filter updates
    document.addEventListener('facet:update', () => {
      console.log('Facet update detected');
      this.updateOverlays();
    });
    
    // Listen for when new content is loaded (Dawn uses this)
    document.addEventListener('shopify:section:load', () => {
      console.log('Section loaded');
      this.productCards = document.querySelectorAll('.card-wrapper, .product-card-wrapper');
      this.updateOverlays();
    });
    
    // URL changes (back/forward navigation)
    window.addEventListener('popstate', () => {
      console.log('Popstate detected');
      this.updateOverlays();
    });
    
    // Watch for DOM changes in the product grid (collection and search)
    const productGrid = document.querySelector('#ProductGridContainer') || 
                        document.querySelector('#product-grid') || 
                        document.querySelector('.collection') ||
                        document.querySelector('[id*="product-grid"]');

    if (productGrid) {
      console.log('Watching grid:', productGrid.id || productGrid.className);
      const observer = new MutationObserver(() => {
        console.log('Product grid mutated - refreshing cards');
        this.productCards = document.querySelectorAll('.card-wrapper, .product-card-wrapper');
        this.updateOverlays();
      });
      
      observer.observe(productGrid, {
        childList: true,
        subtree: true
      });
    } else {
      console.log('No product grid found to observe');
    }

    // Initial check on page load
    console.log('Running initial overlay check');
    this.updateOverlays();
  }

  updateOverlays() {
    const activeFilters = this.getActiveFilters();
    console.log('Active filters:', activeFilters);
    
    this.productCards.forEach(card => {
      // Check both the card wrapper and inner card for data attributes
      let productCard = card.querySelector('.card__inner, .card');
      if (!productCard) productCard = card;
      
      // Try to get data from the element or its child
      let variantsData = productCard.dataset?.variantsStock || card.querySelector('[data-variants-stock]')?.dataset?.variantsStock;
      let variantsOptions = productCard.dataset?.variantsOptions || card.querySelector('[data-variants-options]')?.dataset?.variantsOptions;
      
      if (!variantsData || !variantsOptions) return;

      try {
        const variants = JSON.parse(variantsData);
        const options = JSON.parse(variantsOptions);
        
        const shouldShowBadge = this.shouldShowOutOfStockBadge(variants, options, activeFilters);
        
        if (shouldShowBadge) {
          console.log('Showing overlay for card');
          this.showOverlay(card);
        } else {
          this.hideOverlay(card);
        }
      } catch (e) {
        console.error('Error parsing variant data:', e);
      }
    });
  }

  shouldShowOutOfStockBadge(variants, options, filters) {
    // Only show badge if there are active filters (size or size+fit)
    if (Object.keys(filters).length === 0) {

      return false;
    }
    
    // Find all variants that match the active filters
    const matchingVariants = this.findMatchingVariants(variants, options, filters);
    
    // Show badge only if:
    // 1. There are matching variants (the filtered combination exists)
    // 2. ALL matching variants are out of stock
    if (matchingVariants.length > 0) {
      const allMatchingOutOfStock = matchingVariants.every(variant => !variant.available);

      return allMatchingOutOfStock;
    }
    
    // No matching variants found - don't show badge
    return false;
  }

  getActiveFilters() {
    const params = new URLSearchParams(window.location.search);
    const filters = {};
    
    // Get ALL values for each filter key
    for (const [key, value] of params.entries()) {
      if (key.startsWith('filter.v.option')) {
        const optionName = key.replace('filter.v.option.', '');
        if (!filters[optionName]) {
          filters[optionName] = [];
        }
        filters[optionName].push(value);
      }
    }
    
    return filters;
  }

  findMatchingVariants(variants, options, filters) {
    return variants.filter(variant => {
      const matches = Object.entries(filters).every(([filterName, filterValues]) => {
        const optionIndex = options.findIndex(opt => 
          opt.toLowerCase() === filterName.toLowerCase()
        );
        
        if (optionIndex === -1) return true;
        
        const variantOption = variant.options[optionIndex];
        
        // Check if variant option matches ANY of the filter values (array)
        return variantOption && filterValues.includes(variantOption);
      });
      
      if (matches) console.log('Found matching variant:', variant);
      return matches;
    });
  }


  showOverlay(card) {
    card.classList.add('variant-out-of-stock');
    
    if (!card.querySelector('.variant-stock-overlay')) {
      const overlay = document.createElement('div');
      overlay.className = 'variant-stock-overlay';
      overlay.innerHTML = '<span class="variant-stock-badge">' + window.lyT('sizeSoldOut', 'Size sold out') + '</span>';
      card.querySelector('.card__inner, .card')?.appendChild(overlay);
    }
  }

  hideOverlay(card) {
    card.classList.remove('variant-out-of-stock');
    const overlay = card.querySelector('.variant-stock-overlay');
    if (overlay) overlay.remove();
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new VariantStockOverlay());
} else {
  new VariantStockOverlay();
}
